<template>
    <b-overlay :show="pdfLoading" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block ml-2">
        <b-button variant="custom-outline-secondary" class="fs-14 mt-2" @click="downloadPDF"> Скачать контракт </b-button>
    </b-overlay>
</template>

<script>
import FileDownload from 'js-file-download';

export default {
    name: 'fl44-unknown-volume-download-purchase-contract-pdf-button',
    props: {
        purchaseId: {
            type: Number,
            required: true
        },
        reg_number: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            pdfLoading: false
        };
    },
    methods: {
        downloadPDF() {
            this.pdfLoading = true;
            this.$api.products.fl44UnknownVolume.purchases
                .downloadPurchaseContractPdf(this.purchaseId)
                .then((response) => {
                    const fileName = `Контракт ${this.reg_number}.pdf`;
                    FileDownload(response.data, fileName);
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.pdfLoading = false;
                });
        }
    }
};
</script>
